export const convertStringToAscii = (value: string): Array<number> => {
  let encoder = new TextEncoder();
  let array = Array.from(encoder.encode(value));
  return array;
};
